import React, { Fragment } from "react";
import * as debounce from "lodash.debounce";
import InputRange from "react-input-range";
import { range } from "lodash";

class RangeSlider extends React.Component {
  constructor(props) {
    super(props);
    let maxMinValues = this.props.itemValue.id.split("-");
    let itemValues = this.props.group.selectedOptions.length ? this.props.group.selectedOptions[0].split("-") : maxMinValues;
    itemValues[0] = itemValues[0] < maxMinValues[0]  || itemValues[0] > maxMinValues[1] ? maxMinValues[0] : itemValues[0];
    itemValues[1] = itemValues[1] < maxMinValues[0]  || itemValues[1] > maxMinValues[1] ? maxMinValues[1] : itemValues[1];
    this.state = {
      value: {
        min: parseFloat(itemValues[0]),
        max: parseFloat(itemValues[1]),
      },
      valueInputs: {
        min: parseFloat(itemValues[0]),
        max: parseFloat(itemValues[1]),
      },
      minValue: parseFloat(maxMinValues[0]),
      maxValue: parseFloat(maxMinValues[1]),
    };
  }
  componentDidUpdate(prevProps) {
    // If filter is removed set values to min & max
    if (this.props.group.selectedOptions[0] === undefined &&  prevProps.group.selectedOptions.length && prevProps.group.selectedOptions[0] != undefined) {
      this.setState(() => ({
        value: {
          min: this.state.minValue,
          max: this.state.maxValue,
        },
        valueInputs: {
          min: this.state.minValue,
          max: this.state.maxValue,
        },
      }));
    }
  }

  onRangeChange(rangeValues) {
    if (rangeValues.max > this.state.maxValue) {
      rangeValues.max = this.state.maxValue;
    }
    if (rangeValues.min < this.state.minValue) {
      rangeValues.min = this.state.minValue;
    }
    this.setState(() => ({
      value: {
        min: rangeValues.min,
        max: rangeValues.max,
      },
      valueInputs: {
        min: rangeValues.min,
        max: rangeValues.max,
      },
    }));
  }

  checkIfWithinRange(newValue, id) {
    if (id === "max") {
      if (newValue < this.state.valueInputs.min) {
        newValue = this.state.valueInputs.min + 1;
      } else if (newValue > this.state.maxValue) {
        newValue = this.state.maxValue;
      }
    } else {
      if (newValue > this.state.valueInputs.max) {
        newValue = this.state.valueInputs.max - 1;
      } else if (newValue < this.state.minValue) {
        newValue = this.state.minValue;
      }
    }
    return newValue;
  }
  onInputChange(newValue, id) {
    this.setState((previousState) => ({
      valueInputs: {
        ...previousState.valueInputs,
        [id]: Number(newValue),
      },
    }));

    if (
      id === "min" &&
      newValue > this.state.minValue &&
      newValue < this.state.valueInputs.max
    ) {
      this.onInputDebounce(newValue, id);
    } else if (
      id === "max" &&
      newValue < this.state.maxValue &&
      newValue > this.state.valueInputs.min
    ) {
      this.onInputDebounce(newValue, id);
    }
  }
  onInputDebounce = debounce((value, id) => {
    this.onInputBlur(value, id);
  }, 1000);

  onInputBlur(newValue, id) {
    const updatedValue = this.checkIfWithinRange(newValue, id);

    this.setState((previousState) => ({
      valueInputs: {
        ...previousState.valueInputs,
        [id]: Number(updatedValue),
      },
      value: {
        ...previousState.value,
        [id]: Number(updatedValue),
      },
    }));
    this.props.sliderFilterChange(this.props.group, this.state.value, this.props.productId);
  }

  render() {
    let itemValues = this.props.itemValue.id.split("-");

    return (
      <Fragment>
        <div className="input-range__inputs">
          <input
            type="number"
            value={this.state.valueInputs.min}
            onChange={(e) => this.onInputChange(e.target.value, "min")}
            onBlur={(e) => this.onInputBlur(e.target.value, "min")}
          />
          <input
            type="number"
            value={this.state.valueInputs.max}
            onChange={(e) => this.onInputChange(e.target.value, "max")}
            onBlur={(e) => this.onInputBlur(e.target.value, "max")}
          />
        </div>
        <InputRange
          maxValue={parseFloat(itemValues[1])}
          minValue={parseFloat(itemValues[0])}
          value={this.state.value}
          onChange={(value) => {
            this.onRangeChange(value);
          }}
          onChangeComplete={(value) => {
            this.props.sliderFilterChange(this.props.group, value, this.props.productId);
          }}
        />
      </Fragment>
    );
  }
}

export default RangeSlider;
